// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
 
// require styles
import 'swiper/dist/css/swiper.css'
import '../static/css/font-awesome.min.css'
import 'iview/dist/styles/iview.css'
 
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

var defines={}
	defines.html_url='http://rijihua.api.chengmikeji.com/';
Object.keys(defines).forEach((key)=>{
    Vue.prototype[key] = defines[key];
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js